import { useField } from 'formik';
import React__default, { useCallback } from 'react';
import styled, { css } from 'styled-components';
import { Box } from '../layout/Box.js';
import { CSSGenerateTextFieldError } from '../styles/cssGenerateField.js';
import { Text } from '../text/Text.js';
import { hasError } from './Field.js';

/**
 * local consts
 */ const FIELD_ERROR_DATA_ATTRIBUTE = "data-hpy-web-field-haserror";
/**
 * Field shared error data attribute
 */ const setErrorDataAttribute = (hasError)=>hasError ? {
        [FIELD_ERROR_DATA_ATTRIBUTE]: ""
    } : {};
/**
 * Styled components
 */ const StyledBox = styled(Box)`
  min-height: ${(props)=>props.reserveMessageSpace ? "1em" : 0};
  ${(props)=>!props.reserveMessageSpace && css`
      && {
        margin-top: 0;
      }
    `};
  ${CSSGenerateTextFieldError(true)}
`;
/**
 * Generic Field error message
 */ const FieldErrorMessage = ({ name , error , reserveMessageSpace =true  })=>{
    const [field, meta] = useField(name);
    const getErrorMessage = useCallback(()=>{
        if (hasError(meta)) {
            const metaError = meta.error;
            const errorMessage = typeof metaError === "string" ? metaError : metaError[Object.keys(metaError)[0]];
            return errorMessage;
        } else {
            return !!error ? error : "";
        }
    }, [
        error,
        meta
    ]);
    return React__default.createElement(StyledBox, {
        reserveMessageSpace: reserveMessageSpace,
        "data-hpy-web-fielderrormessage": true
    }, React__default.createElement(Text, {
        size: "small"
    }, getErrorMessage()));
};
FieldErrorMessage.dataId = "data-hpy-web-fielderrormessage";
FieldErrorMessage.displayName = "FieldErrorMessage";

export { FIELD_ERROR_DATA_ATTRIBUTE, FieldErrorMessage, setErrorDataAttribute };
